import { Input } from "@win-reality/react-ui";
import { LoaderCircle, Search } from "lucide-react";
import React from "react";

interface SearchInputProps {
  value: string;
  onSearch: (searchTerm: string) => void;
  className?: string;
  loading?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onSearch,
  className,
  loading,
}) => {
  return (
    <Input
      type="text"
      value={value}
      onChange={(e) => onSearch(e.target.value)}
      placeholder="Search"
      className={className}
      isClearable={!!value}
      onClear={() => onSearch("")}
      iconRight={
        loading ? (
          <LoaderCircle className="animate-spin" />
        ) : (
          <Search strokeWidth={1} />
        )
      }
    />
  );
};

export default SearchInput;
